import { render, staticRenderFns } from "./ServiceTypeList.vue?vue&type=template&id=5f92475f&scoped=true"
import script from "./ServiceTypeList.vue?vue&type=script&lang=js"
export * from "./ServiceTypeList.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeList.vue?vue&type=style&index=0&id=5f92475f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f92475f",
  null
  
)

export default component.exports